/**
 * Layout
 */
export default {
  name: 'layout',
  props: {
    width: {
      type: String,
      default: 'auto',
    },
  },
};



// WEBPACK FOOTER //
// ./src/comp/Layout/_.js